/**
 *
 *
 *
 *
 *
 */
export const SPONSORED_SHEET_TAG = "ofc-sponsored-sheet-v1";

/**
 *
 *
 *
 *
 */
export const SPONSORED_SHEET_ID = "ofc-sponsored-sheet";
